import React, { useState, useRef } from "react";
import { Row } from "reactstrap";
import { useFormik, FormikProvider, Field } from "formik";
import * as OFMSUI from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import HousingService from "../../Services/HousingService";
import * as Yup from "yup";
import jsPDF from "jspdf";
import { MdPictureAsPdf } from "react-icons/md";
import XLSX from "xlsx";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import NavigationServicesHeader from "../../Header/NavigationServicesHeader";
import { autoTable } from "jspdf-autotable";
import moment from "moment-timezone";
import { store } from "../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useReactToPrint } from "react-to-print";
import { FaPrint } from "react-icons/fa";
function StageUpdatePaymentsReport() {
  const history = useHistory();
  const today = new Date();
  const [details, setDetails] = useState([]);
  const [enable, setEnable] = useState(true);
  const [DistList, setDistList] = useState();
  const [casteList, setCasteList] = useState();
  const [PhaseList, setPhaseList] = useState();
  const [show, setShow] = useState();
  const [districtwise, setDistrictWise] = useState();
  const [schemewise, setSchemewise] = useState();
  const [printHead, setPrintHead] = useState("");
  const [dist, setDist] = useState("");
  const [rep, setRep] = useState("");
  const [pha, setPha] = useState("");
  const [cas, setCas] = useState("");
  const [area, setArea] = useState("");
  const [fdate, setFdate] = useState("");
  const [tdate, setTdate] = useState("");
  const [saveOptionCaste, setSaveOptionCaste] = useState([])
  const [saveOptionPhase, setSaveOptionPhase] = useState([])
  const [saveOptionDist, setSaveOptionDist] = useState([])
  const [schemesList1, setSchemesList1] = useState([]);
  const [casteList1, setcasteList1] = useState([]);
  const [distList1, setdistList1] = useState([]);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    documentTitle: "Income Report",
  });

  React.useEffect(() => {
    HousingService.districtlist().then((res) => {
      if (res.data) {
        setdistList1(res.data)
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.dist_code}>
              {item.dist_name}
            </option>
          );
        });
        setDistList(options);
      }
    });
    HousingService.getPhase().then((res) => {
      if (res.data) {
        setSchemesList1(res.data)
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.phase}>
              {item.phase_name}
            </option>
          );
        });
        setPhaseList(options);
      }
    });

    HousingService.getCaste().then((res) => {
      if (res.data) {
        setcasteList1(res.data)
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.caste_id}>
              {item.caste_name}
            </option>
          );
        });
        setCasteList(options);
      }
    });
  }, []);

  const validationSchema = Yup.object({
    fromdate: Yup.date()
      .required("please select fromdate")
      .max(today, "Should not be Greater than Current date"),

    todate: Yup.date()
      .when(["fromdate"], (fromdate, schema) => {
        return fromdate
          ? schema
            .min(fromdate, "shouldnot be less than from date")
            .max(today, "Should not be Greater than Current date")
          : schema.max(0);
      })
      .required("Please Enter Valid Date"),
    phase: Yup.string().required("please select"),
    report_type: Yup.string().required("please select"),
    caste: Yup.string().required("please select"),
    area: Yup.string().required("please select"),
  });

  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const firstDayOfMonth = `${currentYear}-${currentMonth
    .toString()
    .padStart(2, "0")}-01`;

  const formik = useFormik({
    initialValues: {
      phase: "",
      report_type: "",
      caste: "",
      area: "",
      phase_district: "",
      fromdate: firstDayOfMonth,
      todate: today.toISOString().substr(0, 10),
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setDist(formik.values.phase_district);
      setPha(values.phase);
      setCas(values.caste);
      setArea(values.area);
      setRep(values.report_type);
      setFdate(moment(values.fromdate).format("DD/MM/YYYY"));
      setTdate(moment(values.todate).format("DD/MM/YYYY"));

      if (values.phase === "0") {
        setSaveOptionPhase("All")
      }
      else {
        let sch = schemesList1.find((item) => item.phase == values.phase)
        console.log("scheme_name", sch)
        setSaveOptionPhase(sch?.phase_name)
      }

      if (values.phase_district === "0") {
        setSaveOptionDist("All")
      }
      else {
        let dist = distList1.find((item) => item.dist_code == values.phase_district)
        setSaveOptionDist(dist?.dist_name)
      }

      if (values.caste === "0") {
        setSaveOptionCaste("All")
      }
      else {
        let cas = casteList1.find((item) => item.caste_id == values.caste)
        setSaveOptionCaste(cas?.caste_name)
      }

      let params = {
        fromdate: moment(values.fromdate).format("DD/MM/YYYY"),
        todate: moment(values.todate).format("DD/MM/YYYY"),
        report_type: values.report_type,
        dist_code: formik.values.phase_district,
        phase: values.phase,
        caste: values.caste,
        area: values.area,
      };

      if (values.report_type === "DistrictWise") {
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.Ofms_Expenditure(params).then((res) => {
          if (res && res.data && res.data?.length > 0) {
            setDetails(res.data);
            store.dispatch({ type: "HIDE_SPINNER" });
            setShow(true);
            setDistrictWise(true);
            setSchemewise(false);
          }
        });
      }
      if (values.report_type === "SchemeWise") {
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.Ofms_Expenditure(params).then((res) => {
          if (res && res.data && res.data?.length > 0) {
            setDetails(res.data);
            store.dispatch({ type: "HIDE_SPINNER" });
            setShow(true);
            setDistrictWise(false);
            setSchemewise(true);
          }
        });
      }
    },
  });





  function generate() {
    const pageWidth = 210; // A4 width in portrait mode
    const pageHeight = 297; // A4 height in portrait mode
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: [pageWidth, pageHeight] });

    const imgPath = "/img/APSHCL_logo.png";
    const headingText2 = "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText3 = ` ${saveOptionCaste} (Caste) between ${fdate} and ${tdate}, `;
    const headingText4 = `${rep} Expenditure Report of ${saveOptionDist} :District, ${saveOptionPhase} (Phase),`;

    const fontSize = 10;
    const textWidth2 = (doc.getStringUnitWidth(headingText2) * fontSize) / doc.internal.scaleFactor;
    const textWidth3 = (doc.getStringUnitWidth(headingText3) * fontSize) / doc.internal.scaleFactor;
    const textWidth4 = (doc.getStringUnitWidth(headingText4) * fontSize) / doc.internal.scaleFactor;

    const tableYStart = 35;
    doc.setFontSize(fontSize);

    // Set text color to strong black
    doc.setTextColor(0, 0, 0);  // RGB for black

    // Adjusted text coordinates for portrait mode
    const xCoordinate2 = (pageWidth - textWidth2) / 2;
    const xCoordinate3 = (pageWidth - textWidth3) / 2;
    const xCoordinate4 = (pageWidth - textWidth4) / 2;

    doc.text(headingText2, xCoordinate2, 10);
    doc.text(headingText4, xCoordinate4, 20);
    doc.text(headingText3, xCoordinate3, 30);

    // Adjust the image position accordingly
    doc.addImage(imgPath, "PNG", 7, 7, 25, 25);

    // Auto table options
    doc.autoTable({
      html: "#my-table",
      theme: "grid",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" },
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: {
        fontSize: 6,
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 },
    });

    doc.save("ExpenditureReport.pdf");
  }
  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <div className="inner-herbpage-service-title1">
              <h1>COMPLETION, PAYMENT, CEMENT & MATERIAL RELEASED REPORT</h1>
            </div>
          </OFMSUI.Col>

          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="page-titlespacing"
          >
            <button
              className="btn btn-primary"
              style={{ textAlign: "right", float: "right", marginTop: "17px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }}
              type="reset"
              onClick={() => history.goBack()}
            >
              Back
            </button>
            <div className="d-grid  "></div>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>

      <OFMSUI.Container
        fluid
        className="outer-page-content-container"
        style={{ width: "90%" }}
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            {enable && (
              <>
                <OFMSUI.Row className="p-3">
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className="mb-3"
                  >
                    <label>
                      <b>Report Type</b>
                    </label>
                    <span className="mandatory" style={{ color: "red" }}>
                      *
                    </span>
                    <Field
                      component="select"
                      name="report_type"
                      className={
                        formik.touched.report_type && formik.errors.report_type
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    >
                      <option value="">Select</option>
                      <option value="DistrictWise">District-Wise</option>
                      <option value="SchemeWise">Scheme-Wise</option>
                    </Field>
                  </OFMSUI.Col>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                    <label>
                      <h6>District</h6>{" "}
                    </label>{" "}
                    <span className="mandatory" style={{ color: "red" }}>
                      {" "}
                      *{" "}
                    </span>
                    <Field
                      component="select"
                      name="phase_district"
                      className={
                        formik.touched.phase_district &&
                          formik.errors.phase_district
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    >
                      {" "}
                      <option value="">Select</option>{" "}
                      <option value="0">All</option> {DistList}{" "}
                    </Field>
                  </OFMSUI.Col>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className="mb-3"
                  >
                    <label>
                      <b>Phase</b>
                    </label>
                    <span className="mandatory" style={{ color: "red" }}>
                      *
                    </span>
                    <Field
                      component="select"
                      name="phase"
                      className={
                        formik.touched.phase && formik.errors.phase
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    >
                      <option value="">Select</option>
                      <option value="0">All</option>
                      {PhaseList}
                    </Field>
                  </OFMSUI.Col>

                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <label>
                      <b>Caste</b>
                    </label>
                    <span className="mandatory" style={{ color: "red" }}>
                      *
                    </span>

                    <Field
                      component="select"
                      name="caste"
                      className={
                        formik.touched.caste && formik.errors.caste
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    >
                      <option value="">Select</option>
                      <option value="0">All</option>
                      {casteList}
                    </Field>
                  </OFMSUI.Col>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <label>
                      <b>Area</b>
                    </label>
                    <span className="mandatory" style={{ color: "red" }}>
                      *
                    </span>

                    <Field
                      component="select"
                      name="area"
                      className={
                        formik.touched.area && formik.errors.area
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                    >
                      <option value="">select</option>
                      <option value="0">All</option>
                      <option value="1">Rural</option>
                      <option value="2">Urban</option>
                    </Field>
                  </OFMSUI.Col>

                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <label>
                      <b>From Date</b>
                    </label>
                    <span className="mandatory" style={{ color: "red" }}>
                      *
                    </span>

                    <Field
                      name="fromdate"
                      className={
                        formik.touched.fromdate && formik.errors.fromdate
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      type="date"
                    />
                  </OFMSUI.Col>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  >
                    <label>
                      <b>To Date</b>
                    </label>
                    <span className="mandatory" style={{ color: "red" }}>
                      *
                    </span>

                    <Field
                      name="todate"
                      className={
                        formik.touched.todate && formik.errors.todate
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      type="date"
                    />
                  </OFMSUI.Col>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className=""
                  >
                    <div className="d-grid mt-4 ">
                      <button type="submit" className="btn btn-primary" style={{ backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }}>
                        Get Details
                      </button>
                    </div>
                  </OFMSUI.Col>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className=""
                  ></OFMSUI.Col>
                </OFMSUI.Row>
              </>
            )}

            <br />
            <br />
            {show && (
              <>
                <button
                  className="btn btn-danger btn-sm  mb-1"
                  style={{ float: "right", marginLeft: "3px" }}
                  onClick={generate}
                  type="button"
                >
                  PDF
                  <MdPictureAsPdf />
                </button>
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  style={{ float: "right", color: "#fff" }}
                >
                  <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button"
                    table="my-table"
                    filename="Expenditure Report"
                    sheet="tablexls"
                    type="button"
                    buttonText="Excel"
                  ></ReactHTMLTableToExcel>
                </button>

                <button
                  className="btn btn-warning btn-sm"
                  onClick={handlePrint}
                  style={{ float: "right" }}
                  type="button"

                >
                  Print
                  <FaPrint />
                </button>
                <div ref={componentRef} className="print-content">
                  <table
                    striped
                    bordered
                    hover
                    id="my-table"
                    className="table table-bordered table-hover table-striped "
                    indexId="index"
                  >
                    {show && (
                      <thead className="fw-bold">
                        <tr style={{ color: "#fff" }}>
                          <th style={{ background: "#603913" }}>S No.</th>

                          {districtwise && (
                            <th style={{ background: "#603913" }}>
                              District Name
                            </th>
                          )}

                          {schemewise && (
                            <th style={{ background: "#603913" }}>
                              Phase Name
                            </th>
                          )}
                          <th style={{ background: "#603913" }}>No.of Beneficiaries</th>
                          <th style={{ background: "#603913" }}>Completion</th>
                          <th style={{ background: "#603913" }}>Payment</th>
                          <th style={{ background: "#603913" }}>Cement Bags</th>
                          <th style={{ background: "#603913" }}>
                            Cement Payment
                          </th>
                          <th style={{ background: "#603913" }}>
                            Steel Quantity in Kgs
                          </th>

                          <th style={{ background: "#603913" }}>
                            Steel Payment
                          </th>
                          <th style={{ background: "#603913" }}>
                            Other Materials
                          </th>
                          <th style={{ background: "#603913" }}>
                            {" "}
                            Total Material Value
                          </th>
                          <th style={{ background: "#603913" }}>
                            AdminCharges
                          </th>
                          <th style={{ background: "#603913" }}>Total</th>
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {details?.length === 0 || details?.length === undefined ? (
                        <tr>
                          <td colSpan={10} style={{ fontSize: "15px", textAlign: "center" }}> No Data Found </td>
                        </tr>
                      ) : (details?.map((detail, i) => (
                        <tr key={i}>
                          <td style={{ textAlign: "center", width: "1" }}>{i + 1}</td>

                          {districtwise && <td>{detail.dist_name}</td>}
                          {schemewise && <td>{detail.phase_name ? detail.phase_name : "Disabled"}</td>}
                          <td>{parseInt(detail.noben) || 0}</td>
                          <td>{parseInt(detail.comp) || 0}</td>
                          <td>{parseInt(detail.payment) || 0}</td>
                          <td>{parseInt(detail.bags) || 0}</td>
                          <td>{parseInt(detail.cement) || 0}</td>
                          <td>{parseInt(detail.steel_in_kgs) || 0}</td>
                          <td>{parseInt(detail.steel) || 0}</td>
                          <td>{parseInt(detail.other_materials) || 0}</td>
                          <td>{parseInt(detail.total_materials) || 0}</td>
                          <td>{parseInt(detail.admin_charges) || 0}</td>
                          <td>{parseInt(detail.totalexp) || 0}</td>
                        </tr>
                      )))
                      }
                    </tbody>

                    <tfoot>
                      <tr className="table_countshead">
                        <td colSpan={2}>Total</td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.noben) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.comp) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.payment) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.bags) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.cement) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.steel_in_kgs) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.steel) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.other_materials) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.total_materials) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.admin_charges) || 0), 0)}
                        </td>
                        <td>
                          {details?.reduce((a, v) => a + (parseInt(v.totalexp) || 0), 0)}
                        </td>
                      </tr>
                    </tfoot>

                  </table>
                </div>
              </>
            )}
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default StageUpdatePaymentsReport;
